import http from './http';

/**
 * 认证相关接口
 * 实际认证通过 HttpOnly Cookie，前端只维护登录状态标记
 */

let sessionCheckInflight = null;

// 会话检查结果缓存：TTL 内的调用（含路由守卫导航）直接复用，不发请求
// 会话真过期由业务接口 401 兜底（main.js 的 401 回调会同时清空本缓存）
let sessionCache = null; // { data, expiresAt }
const SESSION_CACHE_TTL = 5 * 60 * 1000;

/** 清空会话检查缓存（登录/登出/401 时调用，保证下次检查重新发请求） */
export function clearSessionCache() {
  sessionCache = null;
}

/**
 * 会话检查（结果带 TTL 缓存 + 并发去重：同一时刻多次调用只发一次请求）
 * @param {{ force?: boolean }} [options] force=true 强制发起新请求（跳过缓存）
 * @returns {Promise<object>} sessionCheck 响应 data
 *   - adminRequired / valid / authType / anonymousUpload / username / registerEnabled / userAccountsSupported ...
 */
export function checkSession({ force = false } = {}) {
  // 缓存命中且未过期：直接复用，不发请求
  if (!force && sessionCache && Date.now() < sessionCache.expiresAt) {
    return Promise.resolve(sessionCache.data);
  }

  if (!force && sessionCheckInflight) {
    return sessionCheckInflight;
  }

  const request = http
    .get('/api/auth/sessionCheck')
    .then((res) => {
      const data = res.data;
      // 只缓存成功结果；失败结果（网络错误/503）不缓存
      sessionCache = { data, expiresAt: Date.now() + SESSION_CACHE_TTL };
      return data;
    })
    .finally(() => {
      if (sessionCheckInflight === request) {
        sessionCheckInflight = null;
      }
    });
  sessionCheckInflight = request;
  return request;
}

/** 用户登录（账号模式传 username+password，验证码模式传 authCode） */
export function login(payload) {
  return http.post('/api/auth/login', payload).then((res) => {
    clearSessionCache();
    return res;
  });
}

/** 用户注册 */
export function register(payload) {
  return http.post('/api/auth/register', payload).then((res) => {
    clearSessionCache();
    return res;
  });
}

/** 管理员登录 */
export function adminLogin(payload) {
  return http.post('/api/auth/adminLogin', payload).then((res) => {
    clearSessionCache();
    return res;
  });
}

/** 退出登录（authType: 'admin' | 'user'），fire-and-forget */
export function logout(authType) {
  clearSessionCache();
  return http.post('/api/auth/logout', { authType }).catch(() => {});
}
